var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 0C7.98937 0 0 7.98937 0 17.8334C0 27.6775 7.98937 35.6668 17.8334 35.6668C27.6775 35.6668 35.6668 27.6775 35.6668 17.8334C35.6668 7.98937 27.6775 0 17.8334 0ZM17.8334 5.35002C20.7938 5.35002 23.1834 7.7397 23.1834 10.7C23.1834 13.6604 20.7938 16.0501 17.8334 16.0501C14.8731 16.0501 12.4834 13.6604 12.4834 10.7C12.4834 7.7397 14.8731 5.35002 17.8334 5.35002ZM17.8334 30.6735C13.3751 30.6735 9.43388 28.3908 7.13336 24.9311C7.18686 21.3823 14.2667 19.4384 17.8334 19.4384C21.3823 19.4384 28.48 21.3823 28.5335 24.9311C26.2329 28.3908 22.2918 30.6735 17.8334 30.6735Z",
    fill: "#6D00FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d3c94f3f44be555b4a836b173cd5b037.svg";
export { ForwardRef as ReactComponent };